module.exports = __webpack_public_path__ + "img/payment link asset png.50441984.png";